import { oneKlicks } from "../SDK/oneclick";
import { getBalance, updateuserBalance } from "../services/apiService";
import { debugLog } from "../utils/debug";
const deleteBalanceSheet = async (transaction_id) => {
    debugLog('transaction_id', transaction_id);
    const tableSchema = "";
    const tableName = "balance_sheet";
    const conditions = { transaction_id : transaction_id };
    const orderBy = "id DESC";
    const search = {};
    const pagination = {};
    const margedata = [];

    try {
        const getBalanceSheet = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
        if (!getBalanceSheet.success || !getBalanceSheet.data.length) {
            throw new Error('Failed to get balance sheet');
        }

        const balanceEntry = getBalanceSheet.data[0];
        const currentBalancenew = await getBalance(balanceEntry.account_id); // Assuming function accepts account_id
        debugLog('currentBalancenew', currentBalancenew);
        const credit = parseFloat(balanceEntry.credit || 0);
        const debit = parseFloat(balanceEntry.debit || 0);
        const currentBalance = parseFloat(currentBalancenew || 0);
        debugLog('credit', credit);
        debugLog('debit', debit);

        let adjustedBalance;

        // Revert the balance change (remove credit, or add back debit)
        if (balanceEntry.type == "credit") {
            adjustedBalance = currentBalance - credit;
        } else {
            adjustedBalance = currentBalance + debit;
        }

        debugLog('adjustedBalance', adjustedBalance);
        debugLog('balanceEntry.account_id', balanceEntry.account_id);


        const updateBalanceResult = await updateuserBalance(adjustedBalance, balanceEntry.account_id);
        debugLog('updateBalanceResult', updateBalanceResult);
        if (!updateBalanceResult.success) {
            throw new Error('Failed to update user balance');
        }

        const result = await oneKlicks.delete(tableSchema, tableName, conditions);
        if (!result.success) {
            throw new Error('Failed to delete balance sheet entry');
        }

        return result;
    } catch (error) {
        debugLog("Delete Balance Sheet Error:", error);
        throw error;
    }
};

export default deleteBalanceSheet;
